<article *ngIf="word"
         class="result-detail-layout1"
         style="padding-bottom: 80px;">

  <div #wordBox
       class="detail-head-box">
    <div #wordOption
         class="item-option-box">

      <div class="option-box">
        <app-word-play-btn [word]="word"></app-word-play-btn>
      </div>

      <div class="option-box">
        <app-word-record-btn [word]="word"></app-word-record-btn>
      </div>

      <div class="option-box">
        <article class="bookmark-btn-box">
          <button *ngIf="word"
                  type="button"
                  class="bookmark-btn {{ getBmCss(word) }}"
                  (click)="ToggleBookmark($event, word)"></button>
        </article>
      </div>

    </div>
    <app-word-disp #wordDisp
                   [word]="word"
                   [large]="true"
                   [showLevel]="showLevel"
                   [hanjaLink]="true"
                   [wrapHanja]="true"
                   [wrapReservedWidth]="wordOptionReservedWidth"
                   [fullWord]="true">
      <!-- 표제어 위쪽 간격을 조건부로 넣는 코드. 사용 안 하게 됐지만, 저장해 놓음 -->
      <!-- [fullWord]="wordDisp.width + wordOption.offsetWidth > wordBox.offsetWidth" -->

    </app-word-disp>
  </div>

  <div class="detail-label-box">

    <div class="label-subject-box">
      <span class="subject-txt"
            *ngFor="let poomsa of word?.partOfSpeech">{{ GetPoomsaTxt(poomsa) }}</span>
    </div>
    <div class="label-list-box">
      <div *ngFor="let hun of word?.hanjaHun"
           class="label-box" >{{ hunBody(hun) }}&nbsp;
        <b>{{ hunChar(hun) }}</b>
      </div>
    </div>

  </div>

  <div class="detail-info-box">

    <!-- div class="info-item-box">
      <div class="subject-box">발음</div>
      <div class="con-box">
        <div class="txt-box">[ 감 : 사 ]</div>
      </div>
    </div -->

    <div class="info-item-box">
      <div class="subject-box">
        <div class="border-box">뜻</div>
      </div>
      <div class="con-box">
        <ng-container *ngFor="let mean of word.meaning3; let midx = index">

          <div class="meaning-box" *ngIf="word.GetMeaning3Nth(midx)">

            <div class="txt-list-box">
              <div class="meaning-num"
                   *ngIf="midx !== 0">{{(midx).toString() + '. '}}</div>

              <app-link-content class="txt-box"
                                [content]="mean | resize"></app-link-content>
            </div>

            <!-- 변경된 규칙에 의해서, 뜻이 다수일 때에는 가장 처음 기본 뜻이 오고, 기본 뜻에는 예문이 없다 -->
            <div class="phrases-list"  *ngIf="word?.GetExample3Nth(midx)">
              <div class="phrases-item-box">
                <button type="button"
                        class="phrase-subject-box"
                        [class.on]="showExampleLongVowels"
                        [attr.aria-pressed]="showExampleLongVowels"
                        [attr.aria-label]="showExampleLongVowels ? '예문 수자 표지 숨기기' : '예문 수자 표지 보기'"
                        (click)="ToggleExampleLongVowels($event)">예</button>
                <div class="phrase-con-box">
                  <div *ngFor="let ex of word.GetExample3Nth(midx); let exidx = index"
                       class="example-box">
                    <app-link-content [content]="showExampleLongVowels ? (ex | resize) : (ex | rmLongVowel | resize)"></app-link-content>
                    <div class="record-box">
                      <app-word-ex-play-btn *ngIf="word.GetExVoice(midx, exidx)"
                                            [word]="word"
                                            [exNum]="word.GetExVoiceIdx(midx, exidx)">
                      </app-word-ex-play-btn>
                      <app-word-example-btn *ngIf="word.GetExampleSjNth2(midx, exidx)?.seungjo"
                                            [word]="word"
                                            [exampleSJ]="word.GetExampleSjNth2(midx, exidx)">
                      </app-word-example-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

      </div>
    </div>

    <div class="info-item-box" *ngIf="word?.examples?.length">
      <div class="subject-box">
        <button type="button"
                class="border-box linked-example-toggle-btn"
                [attr.aria-pressed]="showExampleLongVowels"
                [attr.aria-label]="showExampleLongVowels ? '연결 예문 수자 표지 숨기기' : '연결 예문 수자 표지 보기'"
                (click)="ToggleExampleLongVowels($event)">예문</button>
      </div>
      <div class="con-box">
        <div class="linked-example-list">
          <div *ngFor="let example of word.examples"
               class="linked-example-box">
            <app-link-example [example]="example"
                              [showLongVowels]="showExampleLongVowels"></app-link-example>
          </div>
        </div>
      </div>
    </div>

    <div class="info-item-box" *ngIf="word?.synonym">
      <div class="subject-box">
        <div class="border-box">유의어</div>
      </div>
      <div class="con-box">

        <div class="word-list">
          <app-link-content *ngFor="let synonym of word?.synonym"
                            class="word-box"
                            [content]="synonym | resize">
          </app-link-content>
        </div>
      </div>
    </div>

    <div class="info-item-box" *ngIf="word?.derivative">
      <div class="subject-box">
        <div class="border-box">관련어</div>
      </div>
      <div class="con-box">

        <div class="word-list">
          <app-link-content *ngFor="let derivative of word?.derivative"
                            class="word-box"
                            [content]="derivative | resize">
          </app-link-content>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!fromHomonym && word.homonyms"
       class="detail-meaning-box">

    <article class="detail-tit-layout">
      <div class="tit-txt-box">같은 글자, 다른 소리</div>
    </article>

    <div class="meaning-list">

      <app-word-detail-homonym *ngFor="let homonym of word.homonyms"
                               [word]="homonym"
                               [fromHomonym]="fromHomonym">
      </app-word-detail-homonym>
    </div>
  </div>


  <div *ngIf="word.proverbs"
       class="detail-proverb-box">

    <article class="detail-tit-layout">
      <div class="tit-txt-box">속담
        <span class="sub-txt" *ngIf="word.proverbs.length > PROVERB_COUNT_WORD_DETAIL">({{ word.proverbs.length }})</span>
      </div>
      <div class="tit-option-box">
        <a class="option-more-btn"
           *ngIf="word.proverbs.length > PROVERB_COUNT_WORD_DETAIL"
           [routerLink]="['/proverb', LIST_TYPE.SERVER]" [queryParams]="{ word_id: word.id }">더보기</a>

      </div>
    </article>


    <div class="proverb-list">

      <app-word-detail-proverb *ngFor="let proverb of word.proverbs.slice(0, PROVERB_COUNT_WORD_DETAIL)"
                               [proverb]="proverb"></app-word-detail-proverb>

    </div>

  </div>



  <div *ngIf="word.dialects"
       class="detail-other-box">

    <!-- 사투리 지역 팝업창 여는 버튼 컴포넌트 -->
    <app-dialect-map-btn [dialects]="word.dialects"
                         [word]="word"></app-dialect-map-btn>

    <div class="other-list">

      <app-dialect-item *ngFor="let dialect of word.dialects"
                        [dialect]="dialect"
                        [linkPopup]="true"
                        [showNavigationArrow]="true"></app-dialect-item>

    </div>
  </div>


</article>

<div class="reload-img" *ngIf="word === null && IsLoading">
</div>
